import BossModel from "@/models/BossModel";
import Image from "./Image/Image";
import orderBy from 'lodash/orderBy';
import Product from "@/models/Product/Product.js";
import TourNightStay from "@/models/TourNightStay/TourNightStay.js";

export default class Daytoday extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/daytoday';

    /**
     *
     * @type {string}
     */
    static entity = 'productDaytodays';

    static fields() {
		return {
			id: this.number(null).nullable(),
            tour_night_stay_id: this.number(null).nullable(),
            hotel_product_id: this.number(null).nullable(),
			day_number:this.attr(null),
			title: this.attr(null),
			subtitle: this.attr(null),
			sort_order: this.number(null).nullable(),
			text: this.attr(null),
			product_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            images: this.hasMany(Image, 'product_daytoday_id'),
            hotelProduct: this.belongsTo(Product, 'hotel_product_id'),
            tourNightStay: this.belongsTo(TourNightStay, 'tour_night_stay_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get();
    }

    /**
     *
     * @returns {*}
     */
    ProductDaytodayImages(){
        return orderBy(this.getRelated('images'), ['sort_order', 'id']);
    }
}
